import * as React from 'react';
import { connect } from 'react-redux';

import BrandsDropdown from './brands-dropdown/BrandsDropdown';
import BrandTabs from './BrandTabs';

import { brandsFilterUpdated } from 'redux-store/reducers/brands-filter-reducer';
import { getQueryValueFromUrl } from 'utils/url';
import { BRAND_FILTER_QUERY_PARAM } from 'utils/brands';
import { updateQueryParams } from 'utils/location';

import type { InfluencerMeta, LocationWindow } from 'types';

type OwnProps = {
  hideLabel?: boolean,
  mode?: 'dropdown' | 'tabs',
  metaKey?: string,
  influencerMeta?: InfluencerMeta,
  hideCount?: boolean
};

type StateProps = {
  activeBrandFilter: string,
  location: LocationWindow
};

type DispatchProps = {
  dispatchUpdateBrandsFilter: (a: string) => Promise<any>
};

type Props = OwnProps & StateProps & DispatchProps;

class BrandsFilter extends React.PureComponent<Props> {
  static defaultProps: OwnProps = {
    mode: 'dropdown'
  };

  handleDropdownMounted = (options: Array<string>): void => {
    const { location, dispatchUpdateBrandsFilter } = this.props;
    const filterFromLocation = getQueryValueFromUrl(location, BRAND_FILTER_QUERY_PARAM);

    if (filterFromLocation && options.indexOf(filterFromLocation) !== -1) {
      dispatchUpdateBrandsFilter(filterFromLocation);
    }
  };

  handleChange = (activeBrandFilter?: string | null) => {
    const { location, dispatchUpdateBrandsFilter } = this.props;

    if (activeBrandFilter) {
      dispatchUpdateBrandsFilter(activeBrandFilter);

      updateQueryParams(location, { [BRAND_FILTER_QUERY_PARAM]: activeBrandFilter });
    }
  };

  render() {
    const { hideLabel, activeBrandFilter, mode, metaKey, influencerMeta, hideCount } = this.props;

    return (
      mode === 'dropdown' ?
        <BrandsDropdown
          hideLabel={hideLabel}
          activeBrandFilter={activeBrandFilter}
          onChange={this.handleChange}
          onMounted={this.handleDropdownMounted}
        /> :
        <BrandTabs
          metaKey={metaKey}
          influencerMeta={influencerMeta}
          activeBrandFilter={activeBrandFilter}
          hideCount={hideCount}
          onChange={this.handleChange}
        />
    );
  }
}

const mapStateToProps = ({ brandsFilter, router }): StateProps => ({
  location: router.location,
  activeBrandFilter: brandsFilter.activeFilter
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchUpdateBrandsFilter: activeBrandFilter => dispatch(brandsFilterUpdated(activeBrandFilter))
});

export default connect(mapStateToProps, mapDispatchToProps)(BrandsFilter);
